import moment from 'moment';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Grid } from '@mui/material';
import PageHeader from '../components/PageHeader';
import List from '../components/EventSection/List';
import { selectAllEvents } from '../redux/eventsSlice';
import Calendar from '../components/EventSection/Calendar';

function Events() {
  const events = useSelector(selectAllEvents);
  const [tabValue, setTabValue] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);

  const categorizedEvents = events.filter(event => {
    if (tabValue === 0) return true;
    const eventTime = new Date(event.date).setHours(0, 0, 0, 0);
    const todayTime = new Date().setHours(0, 0, 0, 0);
    if (tabValue === 1) return eventTime >= todayTime;
    return eventTime < todayTime;
  });

  const filteredEvents = categorizedEvents.filter(event => {
    if (!selectedDate) return true;
    return moment(event.date).isSame(selectedDate, 'day');
  });

  return (
    <>
      <PageHeader
        title="Upcoming Events"
        backgroundImage="/images/headers/events_bg.jpeg"
        subtitle={'Join us for the most thrilling Gymkhana events across Asia'}
      />
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Calendar
            events={filteredEvents}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
          <List
            tabValue={tabValue}
            events={filteredEvents}
            setTabValue={setTabValue}
          />
        </Grid>
      </Container>
    </>
  );
}

export default Events;
